import { ErrorMessage, Field, Form, FormikProvider, useFormik } from 'formik'
import React, { useEffect, useRef, useState } from 'react'
import CommonFormHeading from '../../CommonUtils/CommonFormHeading'
import * as bie from "react-bootstrap";
import { CommonAxiosGet, CommonAxiosPost } from '../../CommonUtils/CommonAxios';
import { config } from '../../CommonUtils/CommonURLS';
import Swal from 'sweetalert2';
import { failureAlert, successAlert2 } from '../../CommonUtils/SweetAlerts';
import * as Yup from 'yup';
import { ERROR_MSG } from '../../CommonUtils/contextVariables';
import allowNumbersOnly, { AllowFloats, handlePaste } from '../../CommonUtils/CommonValidations';
import { useSelector } from 'react-redux';
import { GetCollegeType } from '../../Reducers/AffiliationCommonservice';
export default function FfcaAdministrativeAreasForm_21() {
    const Collegetype = useSelector((state) => state?.commonMastersReducer?.CollegeType);

    const hasFetchedData = useRef(false);
    const ffcaAdminstrativevalidations = Yup.object().shape({

        ffcaPrincipalRoomsColl: Yup.number().required(ERROR_MSG).nullable(),
        ffcaPrincipalRoomsByUniversity: Yup.number().required(ERROR_MSG).nullable(),

        ffcaPantryRoomsByUniversity: Yup.number().required(ERROR_MSG).nullable(),
        ffcaPantryRoomsColl: Yup.number().required(ERROR_MSG).nullable(),



        ffcaChairSecyRoomsColl: Yup.number().required(ERROR_MSG).nullable(),
        ffcaChairSecyRoomsByUniversity: Yup.number().required(ERROR_MSG).nullable(),


        ffcaBoardRoomsColl: Yup.number().required(ERROR_MSG).nullable(),
        ffcaBoardRoomsByUniversity: Yup.number().required(ERROR_MSG).nullable(),

        ffcaOfficeRoomsColl: Yup.number().required(ERROR_MSG).nullable(),
        ffcaOfficeRoomsByUniversity: Yup.number().required(ERROR_MSG).nullable(),

        ffcaDepartmentRoomsColl: Yup.number().required(ERROR_MSG).nullable(),
        ffcaDepartmentRoomsByUniversity: Yup.number().required(ERROR_MSG).nullable(),

        ffcaHeadDepartmentColl: Yup.number().required(ERROR_MSG).nullable(),
        ffcaHeadDepartmentRoomsByUniversity: Yup.number().required(ERROR_MSG).nullable(),

        ffcaFacultyRoomsColl: Yup.number().required(ERROR_MSG).nullable(),
        ffcaFacultyRoomsByUniversity: Yup.number().required(ERROR_MSG).nullable(),

        ffcaCentralStoresRoomsColl: Yup.number().required(ERROR_MSG).nullable(),
        ffcaCentralStoresRoomsByUniversity: Yup.number().required(ERROR_MSG).nullable(),

        ffcaMaintenanceRoomsColl: Yup.number().required(ERROR_MSG).nullable(),
        ffcaMaintenanceRoomsByUniversity: Yup.number().required(ERROR_MSG).nullable(),

        ffcaSecurityRoomsColl: Yup.number().required(ERROR_MSG).nullable(),
        ffcaSecurityRoomsByUniversity: Yup.number().required(ERROR_MSG).nullable(),

        ffcaHouseKeepingRoomsColl: Yup.number().required(ERROR_MSG).nullable(),
        ffcaHouseKeepingRoomsByUniversity: Yup.number().required(ERROR_MSG).nullable(),

        ffcaExaminationRoomsColl: Yup.number().required(ERROR_MSG).nullable(),
        ffcaExaminationRoomsByUniversity: Yup.number().required(ERROR_MSG).nullable(),

        ffcaPlacementRoomsColl: Yup.number().required(ERROR_MSG).nullable(),
        ffcaPlacementRoomsByUniversity: Yup.number().required(ERROR_MSG).nullable(),

        ffcaIqacRoomsColl: Yup.number().required(ERROR_MSG).nullable(),
        ffcaIqacRoomsByUniversity: Yup.number().required(ERROR_MSG).nullable(),


    });




    const FfcaAdminstrativeFormk = useFormik({

        initialValues: {
            ffcaPrincipalRoomsByUniversity: "",
            ffcaPrincipalRoomsDeficiency: "",
            ffcaBoardRoomsByUniversity: "",
            ffcaBoardRoomsDeficiency: "",
            ffcaOfficeRoomsByUniversity: "",
            ffcaOfficeRoomsDeficiency: "",
            ffcaDepartmentRoomsByUniversity: "",
            ffcaDepartmentRoomsDeficiency: "",
            ffcaHeadDepartmentRoomsByUniversity: "",
            ffcaHeadDepartmentRoomsDeficiency: "",
            ffcaFacultyRoomsByUniversity: "",
            ffcaFacultyRoomsDeficiency: "",
            ffcaCentralStoresRoomsByUniversity: "",
            ffcaCentralStoresRoomsDeficiency: "",
            ffcaMaintenanceRoomsByUniversity: "",
            ffcaMaintenanceRoomsDeficiency: "",
            ffcaSecurityRoomsByUniversity: "",
            ffcaSecurityRoomsDeficiency: "",
            ffcaHouseKeepingRoomsByUniversity: "",
            ffcaHouseKeepingRoomsDeficiency: "",
            ffcaPantryRoomsByUniversity: "",
            ffcaPantryRoomsDeficiency: "",
            ffcaExaminationRoomsByUniversity: "",
            ffcaExaminationRoomsDeficiency: "",
            ffcaPlacementRoomsByUniversity: "",
            ffcaPlacementRoomsDeficiency: "",
            ffcaChairSecyRoomsColl: "",
            ffcaChairSecyRoomsCollDeficiency: "",
            ffcaChairSecyRoomsByUniversity: "",
            ffcaChairSecyRoomsDeficiency: "",
            ffcaPrincipalRoomsColl: "",
            ffcaPrincipalRoomsCollDeficiency: "",
            ffcaBoardRoomsColl: "",
            ffcaBoardRoomsCollDeficiency: "",
            ffcaOfficeRoomsColl: "",
            ffcaOfficeRoomsCollDeficiency: "",
            ffcaDepartmentRoomsColl: "",
            ffcaDepartmentRoomsCollDeficiency: "",
            ffcaHeadDepartmentColl: "",
            ffcaHeadDepartmentRoomsCollDeficiency: "",
            ffcaFacultyRoomsColl: "",
            ffcaFacultyRoomsCollDeficiency: "",
            ffcaCentralStoresRoomsColl: "",
            ffcaCentralStoresRoomsCollDeficiency: "",
            ffcaMaintenanceRoomsColl: "",
            ffcaMaintenanceRoomsCollDeficiency: "",
            ffcaSecurityRoomsColl: "",
            ffcaSecurityRoomsCollDeficiency: "",
            ffcaHouseKeepingRoomsColl: "",
            ffcaHouseKeepingRoomsCollDeficiency: "",
            ffcaPantryRoomsColl: "",
            ffcaPantryRoomsCollDeficiency: "",
            ffcaExaminationRoomsColl: "",
            ffcaExaminationRoomsCollDeficiency: "",
            ffcaPlacementRoomsColl: "",
            ffcaPlacementRoomsCollDeficiency: "",
            ffcaIqacRoomsColl: "",
            ffcaIqacRoomsCollDeficiency: "",
            ffcaIqacRoomsByUniversity: "",
            ffcaIqacRoomsDeficiency: "",
        },
        validationSchema: ffcaAdminstrativevalidations,
        onSubmit: (values) => {

            Swal.fire({
                text: 'Are you sure you want to submit?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, submit it!',
                cancelButtonText: 'No, cancel!',
                backdrop: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    const url = `${config.url.API_URL}saveFfcaAfflAdministrativeArea`;
                    CommonAxiosPost(url, values).then((res) => {
                        if (res?.data?.scode === '01') {
                            successAlert2(res?.data?.sdesc);
                            GetBuildingReport();
                        } else {
                            failureAlert(res?.data?.sdesc);

                        }
                    });
                } else {
                    console.log('Submission canceled');
                }
            });

        },
    })



    const [Administrative, setAdministrative] = useState([])
    function GetBuildingReport() {
        let url = config?.url?.API_URL + "getFfcaAfflAdministrativeAreaReport";
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.status === true && res?.data?.scode === "01") {

                setAdministrative(res?.data?.FfcaAfflAdministrativeAreaReport[0]);


                res?.data?.FfcaAfflAdministrativeAreaReport?.forEach((buildingdata, i) => {
                    FfcaAdminstrativeFormk?.setFieldValue(`ffcaChairSecyRoomsColl`, buildingdata?.ffca_chair_secy_rooms_coll);
                    FfcaAdminstrativeFormk?.setFieldValue(`ffcaChairSecyRoomsCollDeficiency`, buildingdata?.ffca_chair_secy_rooms_coll_deficiency);
                    FfcaAdminstrativeFormk?.setFieldValue(`ffcaChairSecyRoomsByUniversity`, buildingdata?.ffca_chair_secy_rooms_by_university);
                    FfcaAdminstrativeFormk?.setFieldValue(`ffcaChairSecyRoomsDeficiency`, buildingdata?.ffca_chair_secy_rooms_deficiency);

                    FfcaAdminstrativeFormk?.setFieldValue(`ffcaPrincipalRoomsColl`, buildingdata?.ffca_principal_rooms_coll);
                    FfcaAdminstrativeFormk?.setFieldValue(`ffcaPrincipalRoomsCollDeficiency`, buildingdata?.ffca_principal_rooms_coll_deficiency);
                    FfcaAdminstrativeFormk?.setFieldValue(`ffcaPrincipalRoomsByUniversity`, buildingdata?.ffca_principal_rooms_by_university);
                    FfcaAdminstrativeFormk?.setFieldValue(`ffcaPrincipalRoomsDeficiency`, buildingdata?.ffca_principal_rooms_deficiency);

                    FfcaAdminstrativeFormk?.setFieldValue(`ffcaBoardRoomsColl`, buildingdata?.ffca_board_rooms_coll);
                    FfcaAdminstrativeFormk?.setFieldValue(`ffcaBoardRoomsCollDeficiency`, buildingdata?.ffca_board_rooms_coll_deficiency);
                    FfcaAdminstrativeFormk?.setFieldValue(`ffcaBoardRoomsByUniversity`, buildingdata?.ffca_board_rooms_by_university);
                    FfcaAdminstrativeFormk?.setFieldValue(`ffcaBoardRoomsDeficiency`, buildingdata?.ffca_board_rooms_deficiency)

                    FfcaAdminstrativeFormk?.setFieldValue(`ffcaOfficeRoomsColl`, buildingdata?.ffca_office_rooms_coll);
                    FfcaAdminstrativeFormk?.setFieldValue(`ffcaOfficeRoomsCollDeficiency`, buildingdata?.ffca_office_rooms_coll_deficiency);
                    FfcaAdminstrativeFormk?.setFieldValue(`ffcaOfficeRoomsByUniversity`, buildingdata?.ffca_office_rooms_by_university);
                    FfcaAdminstrativeFormk?.setFieldValue(`ffcaOfficeRoomsDeficiency`, buildingdata?.ffca_office_rooms_deficiency);



                    FfcaAdminstrativeFormk?.setFieldValue(`ffcaDepartmentRoomsColl`, buildingdata?.ffca_department_rooms_coll);
                    FfcaAdminstrativeFormk?.setFieldValue(`ffcaDepartmentRoomsCollDeficiency`, buildingdata?.ffca_department_rooms_coll_deficiency);
                    FfcaAdminstrativeFormk?.setFieldValue(`ffcaDepartmentRoomsByUniversity`, buildingdata?.ffca_department_rooms_by_university);
                    FfcaAdminstrativeFormk?.setFieldValue(`ffcaDepartmentRoomsDeficiency`, buildingdata?.ffca_department_rooms_deficiency);

                    FfcaAdminstrativeFormk?.setFieldValue(`ffcaHeadDepartmentColl`, buildingdata?.ffca_head_department_coll);
                    FfcaAdminstrativeFormk?.setFieldValue(`ffcaHeadDepartmentRoomsCollDeficiency`, buildingdata?.ffca_head_department_rooms_coll_deficiency);
                    FfcaAdminstrativeFormk?.setFieldValue(`ffcaHeadDepartmentRoomsByUniversity`, buildingdata?.ffca_head_department_rooms_by_university);
                    FfcaAdminstrativeFormk?.setFieldValue(`ffcaHeadDepartmentRoomsDeficiency`, buildingdata?.ffca_head_department_rooms_deficiency);

                    FfcaAdminstrativeFormk?.setFieldValue(`ffcaFacultyRoomsColl`, buildingdata?.ffca_faculty_rooms_coll);
                    FfcaAdminstrativeFormk?.setFieldValue(`ffcaFacultyRoomsCollDeficiency`, buildingdata?.ffca_faculty_rooms_coll_deficiency);
                    FfcaAdminstrativeFormk?.setFieldValue(`ffcaFacultyRoomsByUniversity`, buildingdata?.ffca_faculty_rooms_by_university);
                    FfcaAdminstrativeFormk?.setFieldValue(`ffcaFacultyRoomsDeficiency`, buildingdata?.ffca_faculty_rooms_deficiency);

                    FfcaAdminstrativeFormk?.setFieldValue(`ffcaCentralStoresRoomsColl`, buildingdata?.ffca_central_stores_rooms_coll);
                    FfcaAdminstrativeFormk?.setFieldValue(`ffcaCentralStoresRoomsCollDeficiency`, buildingdata?.ffca_central_stores_rooms_coll_deficiency);
                    FfcaAdminstrativeFormk?.setFieldValue(`ffcaCentralStoresRoomsByUniversity`, buildingdata?.ffca_central_stores_rooms_by_university);
                    FfcaAdminstrativeFormk?.setFieldValue(`ffcaCentralStoresRoomsDeficiency`, buildingdata?.ffca_central_stores_rooms_deficiency);

                    FfcaAdminstrativeFormk?.setFieldValue(`ffcaMaintenanceRoomsColl`, buildingdata?.ffca_maintenance_rooms_coll);
                    FfcaAdminstrativeFormk?.setFieldValue(`ffcaMaintenanceRoomsCollDeficiency`, buildingdata?.ffca_maintenance_rooms_coll_deficiency);
                    FfcaAdminstrativeFormk?.setFieldValue(`ffcaMaintenanceRoomsByUniversity`, buildingdata?.ffca_maintenance_rooms_by_university);
                    FfcaAdminstrativeFormk?.setFieldValue(`ffcaMaintenanceRoomsDeficiency`, buildingdata?.ffca_maintenance_rooms_deficiency);

                    FfcaAdminstrativeFormk?.setFieldValue(`ffcaSecurityRoomsColl`, buildingdata?.ffca_security_rooms_coll);
                    FfcaAdminstrativeFormk?.setFieldValue(`ffcaSecurityRoomsCollDeficiency`, buildingdata?.ffca_security_rooms_coll_deficiency);
                    FfcaAdminstrativeFormk?.setFieldValue(`ffcaSecurityRoomsByUniversity`, buildingdata?.ffca_security_rooms_by_university);
                    FfcaAdminstrativeFormk?.setFieldValue(`ffcaSecurityRoomsDeficiency`, buildingdata?.ffca_security_rooms_deficiency);

                    FfcaAdminstrativeFormk?.setFieldValue(`ffcaHouseKeepingRoomsColl`, buildingdata?.ffca_house_keeping_rooms_coll);
                    FfcaAdminstrativeFormk?.setFieldValue(`ffcaHouseKeepingRoomsCollDeficiency`, buildingdata?.ffca_house_keeping_rooms_coll_deficiency);
                    FfcaAdminstrativeFormk?.setFieldValue(`ffcaHouseKeepingRoomsByUniversity`, buildingdata?.ffca_house_keeping_rooms_by_university);
                    FfcaAdminstrativeFormk?.setFieldValue(`ffcaHouseKeepingRoomsDeficiency`, buildingdata?.ffca_house_keeping_rooms_deficiency);

                    FfcaAdminstrativeFormk?.setFieldValue(`ffcaPantryRoomsColl`, buildingdata?.ffca_pantry_rooms_coll);
                    FfcaAdminstrativeFormk?.setFieldValue(`ffcaPantryRoomsCollDeficiency`, buildingdata?.ffca_pantry_rooms_coll_deficiency);
                    FfcaAdminstrativeFormk?.setFieldValue(`ffcaPantryRoomsByUniversity`, buildingdata?.ffca_pantry_rooms_by_university);
                    FfcaAdminstrativeFormk?.setFieldValue(`ffcaPantryRoomsDeficiency`, buildingdata?.ffca_pantry_rooms_deficiency);

                    FfcaAdminstrativeFormk?.setFieldValue(`ffcaExaminationRoomsColl`, buildingdata?.ffca_examination_rooms_coll);
                    FfcaAdminstrativeFormk?.setFieldValue(`ffcaExaminationRoomsCollDeficiency`, buildingdata?.ffca_examination_rooms_coll_deficiency);
                    FfcaAdminstrativeFormk?.setFieldValue(`ffcaExaminationRoomsByUniversity`, buildingdata?.ffca_examination_rooms_by_university);
                    FfcaAdminstrativeFormk?.setFieldValue(`ffcaExaminationRoomsDeficiency`, buildingdata?.ffca_examination_rooms_deficiency);

                    FfcaAdminstrativeFormk?.setFieldValue(`ffcaPlacementRoomsColl`, buildingdata?.ffca_placement_rooms_coll);
                    FfcaAdminstrativeFormk?.setFieldValue(`ffcaPlacementRoomsCollDeficiency`, buildingdata?.ffca_placement_rooms_coll_deficiency);
                    FfcaAdminstrativeFormk?.setFieldValue(`ffcaPlacementRoomsByUniversity`, buildingdata?.ffca_placement_rooms_by_university);
                    FfcaAdminstrativeFormk?.setFieldValue(`ffcaPlacementRoomsDeficiency`, buildingdata?.ffca_placement_rooms_deficiency);

                    FfcaAdminstrativeFormk?.setFieldValue(`ffcaIqacRoomsColl`, buildingdata?.ffca_iqac_rooms_coll);
                    FfcaAdminstrativeFormk?.setFieldValue(`ffcaIqacRoomsCollDeficiency`, buildingdata?.ffca_iqac_rooms_coll_deficiency);
                    FfcaAdminstrativeFormk?.setFieldValue(`ffcaIqacRoomsByUniversity`, buildingdata?.ffca_iqac_rooms_by_university);
                    FfcaAdminstrativeFormk?.setFieldValue(`ffcaIqacRoomsDeficiency`, buildingdata?.ffca_iqac_rooms_deficiency);
                })

            }
            else {
                setAdministrative([]);

            }

        })
    }

    useEffect(() => {
        if (!hasFetchedData.current) {
            GetBuildingReport();
            GetCollegeType();
            hasFetchedData.current = true
        }
    }, [])


    const handleKeyUp = (fieldName, collectedValue, totalValue) => {
        const collected = parseFloat(collectedValue || 0);
        const total = parseFloat(totalValue || 0);

        let deficiency = collected - total;

        if (deficiency < 0) {
            deficiency = 0;
        }
        deficiency = parseFloat(deficiency.toFixed(2));

        FfcaAdminstrativeFormk.setFieldValue(fieldName, deficiency);
    };
    return (
        <>
            <CommonFormHeading heading="Administrative Area Details" />
            <bie.Container className="outer-page-content-container shadow-none px-3 m-0 mw-100 pb-5">
                <FormikProvider value={FfcaAdminstrativeFormk}>
                    <Form onChange={FfcaAdminstrativeFormk.handleChange} onSubmit={FfcaAdminstrativeFormk.handleSubmit} className="affl-form" >
                        <bie.Row className="px-2 pt-3 mb-3">
                            <div className="table-responsive">
                                <table className="table table-condensed table-bordered table-sm table-responsive affl-table">
                                    <thead>
                                        <tr>
                                            <th style={{ width: "20%" }}> Particulars</th>
                                            <th>Number provided by college	</th>
                                            <th> Number to be provided as per the Norms</th>
                                            <th>Deficiency ( Number)</th>
                                            <th> Total Area Provided by College( {Collegetype})</th>
                                            <th>Total Area to be provided as per the Norms( {Collegetype}) </th>
                                            <th>Deficiency ( {Collegetype}) </th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        <tr>
                                            <td className='text-left'>Chairperson/Secretary Room	 </td>
                                            <td> {Administrative?.chair_secy_rooms}</td>
                                            <td><Field
                                                type="text" name="ffcaChairSecyRoomsColl" className="form-control" maxLength={8}
                                                onKeyPress={(e) => { allowNumbersOnly(e); }} onPaste={(e) => handlePaste(e)}
                                                onKeyUp={(e) => { handleKeyUp("ffcaChairSecyRoomsCollDeficiency", e.target.value, Administrative?.chair_secy_rooms) }}
                                            />
                                                <ErrorMessage name="ffcaChairSecyRoomsColl" component="div" className="text-error" />

                                            </td>
                                            <td><Field
                                                type="text" name="ffcaChairSecyRoomsCollDeficiency" className="form-control"
                                                value={FfcaAdminstrativeFormk.values.ffcaChairSecyRoomsCollDeficiency} disabled /> </td>
                                            <td>{Administrative?.chair_secy_area} </td>
                                            <td><Field
                                                type="text" name="ffcaChairSecyRoomsByUniversity" className="form-control" onKeyPress={(e) => { AllowFloats(e); }}
                                                onKeyUp={(e) => handleKeyUp("ffcaChairSecyRoomsDeficiency", e.target.value, Administrative?.chair_secy_area)} />
                                                <ErrorMessage name="ffcaChairSecyRoomsByUniversity" component="div" className="text-error" /></td>
                                            <td><Field
                                                type="text" name="ffcaChairSecyRoomsDeficiency"
                                                className="form-control" value={FfcaAdminstrativeFormk.values.ffcaChairSecyRoomsDeficiency} disabled
                                            /> </td>
                                        </tr>
                                        <tr>
                                            <td className='text-left'>Principal Room	</td>
                                            <td> {Administrative?.principal_rooms}</td>
                                            <td><Field
                                                type="text"
                                                name="ffcaPrincipalRoomsColl" maxLength={5}
                                                className="form-control" onKeyPress={(e) => { allowNumbersOnly(e); }} onPaste={(e) => handlePaste(e)}
                                                onKeyUp={(e) => handleKeyUp("ffcaPrincipalRoomsCollDeficiency", e.target.value, Administrative?.principal_rooms)}
                                            /> <ErrorMessage name="ffcaPrincipalRoomsColl" component="div" className="text-error" />
                                            </td>
                                            <td><Field
                                                type="text" name="ffcaPrincipalRoomsCollDeficiency" className="form-control"
                                                value={FfcaAdminstrativeFormk.values.ffcaPrincipalRoomsCollDeficiency} disabled /> </td>
                                            <td>{Administrative?.principal_area} </td>
                                            <td><Field
                                                type="text" name="ffcaPrincipalRoomsByUniversity" className="form-control" onKeyPress={(e) => { AllowFloats(e); }}
                                                onKeyUp={(e) => handleKeyUp("ffcaPrincipalRoomsDeficiency", e.target.value, Administrative?.principal_area)} />
                                                <ErrorMessage name="ffcaPrincipalRoomsByUniversity" component="div" className="text-error" /></td>
                                            <td><Field
                                                type="text" name="ffcaPrincipalRoomsDeficiency"
                                                className="form-control" value={FfcaAdminstrativeFormk.values.ffcaPrincipalRoomsDeficiency} disabled /> </td>
                                        </tr>
                                        <tr>
                                            <td className='text-left'>Board Room	 </td>
                                            <td> {Administrative?.board_rooms}</td>
                                            <td><Field
                                                type="text" name="ffcaBoardRoomsColl" className="form-control" maxLength={8} onKeyPress={(e) => { allowNumbersOnly(e); }} onPaste={(e) => handlePaste(e)}
                                                onKeyUp={(e) => handleKeyUp("ffcaBoardRoomsCollDeficiency", e.target.value, Administrative?.board_rooms)}
                                            /> <ErrorMessage name="ffcaBoardRoomsColl" component="div" className="text-error" />
                                            </td>
                                            <td><Field
                                                type="text"
                                                name="ffcaBoardRoomsCollDeficiency" className="form-control" value={FfcaAdminstrativeFormk.values.ffcaBoardRoomsCollDeficiency}
                                                disabled /> </td>
                                            <td>{Administrative?.board_area} </td>
                                            <td><Field
                                                type="text"
                                                name="ffcaBoardRoomsByUniversity"
                                                className="form-control" onKeyPress={(e) => { AllowFloats(e); }}
                                                onKeyUp={(e) =>
                                                    handleKeyUp("ffcaBoardRoomsDeficiency", e.target.value, Administrative?.board_area)} />
                                                <ErrorMessage name="ffcaBoardRoomsByUniversity" component="div" className="text-error" />
                                            </td>
                                            <td><Field
                                                type="text"
                                                name="ffcaBoardRoomsDeficiency"
                                                value={FfcaAdminstrativeFormk.values.ffcaBoardRoomsDeficiency}
                                                className="form-control"
                                                disabled
                                            /> </td>
                                        </tr>
                                        <tr>
                                            <td className='text-left'>Office Room		 </td>
                                            <td> {Administrative?.office_rooms}</td>
                                            <td><Field type="text" name="ffcaOfficeRoomsColl" className="form-control" maxLength={8} onKeyPress={(e) => { allowNumbersOnly(e); }} onPaste={(e) => handlePaste(e)}
                                                onKeyUp={(e) => handleKeyUp("ffcaOfficeRoomsCollDeficiency", e.target.value, Administrative?.office_rooms)} />
                                                <ErrorMessage name="ffcaOfficeRoomsColl" component="div" className="text-error" /></td>
                                            <td><Field
                                                type="text"
                                                name="ffcaOfficeRoomsCollDeficiency"
                                                className="form-control" value={FfcaAdminstrativeFormk.values.ffcaOfficeRoomsCollDeficiency}
                                                disabled
                                            /> </td>
                                            <td>{Administrative?.office_area} </td>
                                            <td><Field
                                                type="text"
                                                name="ffcaOfficeRoomsByUniversity"
                                                className="form-control" onKeyPress={(e) => { AllowFloats(e); }}
                                                onKeyUp={(e) => handleKeyUp("ffcaOfficeRoomsDeficiency", e.target.value, Administrative?.office_area)} />
                                                <ErrorMessage name="ffcaOfficeRoomsByUniversity" component="div" className="text-error" /> </td>
                                            <td><Field
                                                type="text"
                                                name="ffcaOfficeRoomsDeficiency"
                                                className="form-control" value={FfcaAdminstrativeFormk.values.ffcaOfficeRoomsDeficiency}
                                                disabled
                                            /> </td>




                                        </tr>
                                        <tr>
                                            <td className='text-left'>Department Office	</td>
                                            <td> {Administrative?.department_rooms}</td>
                                            <td><Field
                                                type="text"
                                                name="ffcaDepartmentRoomsColl"
                                                className="form-control" maxLength={8} onKeyPress={(e) => { allowNumbersOnly(e); }} onPaste={(e) => handlePaste(e)}
                                                onKeyUp={(e) => handleKeyUp("ffcaDepartmentRoomsCollDeficiency", e.target.value, Administrative?.department_rooms)} />
                                                <ErrorMessage name="ffcaDepartmentRoomsColl" component="div" className="text-error" /> </td>
                                            <td><Field
                                                type="text"
                                                name="ffcaDepartmentRoomsCollDeficiency"
                                                className="form-control" value={FfcaAdminstrativeFormk.values.ffcaDepartmentRoomsCollDeficiency}
                                                disabled
                                            /> </td>
                                            <td>{Administrative?.department_area} </td>
                                            <td><Field
                                                type="text"
                                                name="ffcaDepartmentRoomsByUniversity"
                                                className="form-control" onKeyPress={(e) => { AllowFloats(e); }}
                                                onKeyUp={(e) => handleKeyUp("ffcaDepartmentRoomsDeficiency", e.target.value, Administrative?.department_area)} />
                                                <ErrorMessage name="ffcaDepartmentRoomsByUniversity" component="div" className="text-error" /> </td>

                                            <td><Field
                                                type="text"
                                                name="ffcaDepartmentRoomsDeficiency" value={FfcaAdminstrativeFormk.values.ffcaDepartmentRoomsDeficiency}
                                                className="form-control"
                                                disabled
                                            /> </td>

                                        </tr>
                                        <tr>
                                            <td className='text-left'>Head of Department	 </td>
                                            <td> {Administrative?.head_department_rooms}</td>
                                            <td><Field
                                                type="text"
                                                name="ffcaHeadDepartmentColl"
                                                className="form-control" maxLength={8} onKeyPress={(e) => { allowNumbersOnly(e); }} onPaste={(e) => handlePaste(e)}
                                                onKeyUp={(e) => handleKeyUp("ffcaHeadDepartmentRoomsCollDeficiency", e.target.value, Administrative?.head_department_rooms)} />
                                                <ErrorMessage name="ffcaHeadDepartmentColl" component="div" className="text-error" />
                                            </td>

                                            <td><Field
                                                type="text"
                                                name="ffcaHeadDepartmentRoomsCollDeficiency"
                                                className="form-control" value={FfcaAdminstrativeFormk.values.ffcaHeadDepartmentRoomsCollDeficiency}
                                                disabled
                                            /> </td>
                                            <td>{Administrative?.head_department_area} </td>
                                            <td><Field
                                                type="text"
                                                name="ffcaHeadDepartmentRoomsByUniversity"
                                                className="form-control" onKeyPress={(e) => { AllowFloats(e); }}
                                                onKeyUp={(e) => handleKeyUp("ffcaHeadDepartmentRoomsDeficiency", e.target.value, Administrative?.head_department_area)} />
                                                <ErrorMessage name="ffcaHeadDepartmentRoomsByUniversity" component="div" className="text-error" />
                                            </td>

                                            <td><Field
                                                type="text"
                                                name="ffcaHeadDepartmentRoomsDeficiency"
                                                className="form-control" value={FfcaAdminstrativeFormk.values.ffcaHeadDepartmentRoomsDeficiency}
                                                disabled
                                            /> </td>
                                        </tr>
                                        <tr>
                                            <td className='text-left'>Faculty Rooms	</td>
                                            <td> {Administrative?.faculty_rooms}</td>
                                            <td><Field
                                                type="text"
                                                name="ffcaFacultyRoomsColl"
                                                className="form-control" maxLength={8} onKeyPress={(e) => { allowNumbersOnly(e); }} onPaste={(e) => handlePaste(e)}
                                                onKeyUp={(e) => handleKeyUp("ffcaFacultyRoomsCollDeficiency", e.target.value, Administrative?.faculty_rooms)} />
                                                <ErrorMessage name="ffcaFacultyRoomsColl" component="div" className="text-error" /></td>

                                            <td><Field
                                                type="text"
                                                name="ffcaFacultyRoomsCollDeficiency"
                                                className="form-control"
                                                value={FfcaAdminstrativeFormk.values.ffcaFacultyRoomsCollDeficiency}
                                                disabled
                                            /> </td>
                                            <td>{Administrative?.faculty_area} </td>
                                            <td><Field
                                                type="text"
                                                name="ffcaFacultyRoomsByUniversity"
                                                className="form-control" onKeyPress={(e) => { AllowFloats(e); }}
                                                onKeyUp={(e) => handleKeyUp("ffcaFacultyRoomsDeficiency", e.target.value, Administrative?.faculty_area)} />
                                                <ErrorMessage name="ffcaFacultyRoomsByUniversity" component="div" className="text-error" />
                                            </td>

                                            <td><Field
                                                type="text"
                                                name="ffcaFacultyRoomsDeficiency"
                                                className="form-control"
                                                value={FfcaAdminstrativeFormk.values.ffcaFacultyRoomsDeficiency}
                                                disabled
                                            /> </td>
                                        </tr>
                                        <tr>
                                            <td className='text-left'>Central Stores	 </td>
                                            <td> {Administrative?.central_stores_rooms}</td>
                                            <td><Field
                                                type="text"
                                                name="ffcaCentralStoresRoomsColl"
                                                className="form-control" maxLength={8} onKeyPress={(e) => { allowNumbersOnly(e); }} onPaste={(e) => handlePaste(e)}
                                                onKeyUp={(e) => handleKeyUp("ffcaCentralStoresRoomsCollDeficiency", e.target.value, Administrative?.central_stores_rooms)} />
                                                <ErrorMessage name="ffcaCentralStoresRoomsColl" component="div" className="text-error" />
                                            </td>

                                            <td><Field
                                                type="text"
                                                name="ffcaCentralStoresRoomsCollDeficiency"
                                                className="form-control"
                                                value={FfcaAdminstrativeFormk.values.ffcaCentralStoresRoomsCollDeficiency}
                                                disabled
                                            /> </td>
                                            <td>{Administrative?.central_stores_area} </td>
                                            <td><Field
                                                type="text"
                                                name="ffcaCentralStoresRoomsByUniversity"
                                                className="form-control" onKeyPress={(e) => { AllowFloats(e); }}
                                                onKeyUp={(e) => handleKeyUp("ffcaCentralStoresRoomsDeficiency", e.target.value, Administrative?.central_stores_area)} />
                                                <ErrorMessage name="ffcaCentralStoresRoomsByUniversity" component="div" className="text-error" />
                                            </td>

                                            <td><Field
                                                type="text"
                                                name="ffcaCentralStoresRoomsDeficiency"
                                                className="form-control"
                                                value={FfcaAdminstrativeFormk.values.ffcaCentralStoresRoomsDeficiency}
                                                disabled
                                            /> </td>
                                        </tr>
                                        <tr>
                                            <td className='text-left'>Maintenance </td>
                                            <td> {Administrative?.maintenance_rooms}</td>
                                            <td><Field
                                                type="text"
                                                name="ffcaMaintenanceRoomsColl"
                                                className="form-control" maxLength={8} onKeyPress={(e) => { allowNumbersOnly(e); }} onPaste={(e) => handlePaste(e)}
                                                onKeyUp={(e) => handleKeyUp("ffcaMaintenanceRoomsCollDeficiency", e.target.value, Administrative?.maintenance_rooms)} />
                                                <ErrorMessage name="ffcaMaintenanceRoomsColl" component="div" className="text-error" />
                                            </td>

                                            <td><Field
                                                type="text"
                                                name="ffcaMaintenanceRoomsCollDeficiency"
                                                value={FfcaAdminstrativeFormk.values.ffcaMaintenanceRoomsCollDeficiency}
                                                className="form-control"
                                                disabled
                                            /> </td>
                                            <td>{Administrative?.maintenance_area} </td>
                                            <td><Field
                                                type="text" name="ffcaMaintenanceRoomsByUniversity"
                                                className="form-control" onKeyPress={(e) => { AllowFloats(e); }}
                                                onKeyUp={(e) => handleKeyUp("ffcaMaintenanceRoomsDeficiency", e.target.value, Administrative?.maintenance_area)} />
                                                <ErrorMessage name="ffcaMaintenanceRoomsByUniversity" component="div" className="text-error" />
                                            </td>

                                            <td><Field
                                                type="text"
                                                name="ffcaMaintenanceRoomsDeficiency"
                                                className="form-control"
                                                value={FfcaAdminstrativeFormk.values.ffcaMaintenanceRoomsDeficiency}

                                                disabled
                                            /> </td>

                                        </tr>
                                        <tr>
                                            <td className='text-left'>Security </td>
                                            <td> {Administrative?.security_rooms}</td>
                                            <td><Field
                                                type="text"
                                                name="ffcaSecurityRoomsColl"
                                                className="form-control" maxLength={8} onKeyPress={(e) => { allowNumbersOnly(e); }} onPaste={(e) => handlePaste(e)}
                                                onKeyUp={(e) => handleKeyUp("ffcaSecurityRoomsCollDeficiency", e.target.value, Administrative?.security_rooms)} />
                                                <ErrorMessage name="ffcaSecurityRoomsColl" component="div" className="text-error" />
                                            </td>
                                            <td><Field
                                                type="text"
                                                name="ffcaSecurityRoomsCollDeficiency"
                                                className="form-control"
                                                value={FfcaAdminstrativeFormk.values.ffcaSecurityRoomsCollDeficiency}

                                                disabled
                                            /> </td>
                                            <td>{Administrative?.security_area} </td>
                                            <td><Field
                                                type="text"
                                                name="ffcaSecurityRoomsByUniversity"
                                                className="form-control" onKeyPress={(e) => { AllowFloats(e); }}
                                                onKeyUp={(e) => handleKeyUp("ffcaSecurityRoomsDeficiency", e.target.value, Administrative?.security_area)} />
                                                <ErrorMessage name="ffcaSecurityRoomsByUniversity" component="div" className="text-error" />
                                            </td>

                                            <td><Field
                                                type="text"
                                                name="ffcaSecurityRoomsDeficiency"
                                                className="form-control"
                                                value={FfcaAdminstrativeFormk.values.ffcaSecurityRoomsDeficiency}

                                                disabled
                                            /> </td>
                                        </tr>

                                        <tr>
                                            <td className='text-left'>House Keeping	</td>
                                            <td> {Administrative?.house_keeping_rooms}</td>
                                            <td><Field
                                                type="text"
                                                name="ffcaHouseKeepingRoomsColl"
                                                className="form-control"
                                                maxLength={8} onKeyPress={(e) => { allowNumbersOnly(e); }} onPaste={(e) => handlePaste(e)}
                                                onKeyUp={(e) => handleKeyUp("ffcaHouseKeepingRoomsCollDeficiency", e.target.value, Administrative?.house_keeping_rooms)} />
                                                <ErrorMessage name="ffcaHouseKeepingRoomsColl" component="div" className="text-error" />
                                            </td>

                                            <td><Field
                                                type="text"
                                                name="ffcaHouseKeepingRoomsCollDeficiency"
                                                className="form-control"
                                                value={FfcaAdminstrativeFormk.values.ffcaHouseKeepingRoomsCollDeficiency}

                                                disabled
                                            /> </td>
                                            <td>{Administrative?.house_keeping_area} </td>
                                            <td><Field
                                                type="text"
                                                name="ffcaHouseKeepingRoomsByUniversity"
                                                className="form-control" onKeyPress={(e) => { AllowFloats(e); }}
                                                onKeyUp={(e) => handleKeyUp("ffcaHouseKeepingRoomsDeficiency", e.target.value, Administrative?.house_keeping_area)} />
                                                <ErrorMessage name="ffcaHouseKeepingRoomsByUniversity" component="div" className="text-error" />
                                            </td>

                                            <td><Field
                                                type="text"
                                                name="ffcaHouseKeepingRoomsDeficiency"
                                                className="form-control"
                                                value={FfcaAdminstrativeFormk.values.ffcaHouseKeepingRoomsDeficiency}

                                                disabled
                                            /> </td>

                                        </tr>
                                        <tr>
                                            <td className='text-left'>Pantry		 </td>
                                            <td> {Administrative?.pantry_rooms}</td>
                                            <td><Field
                                                type="text"
                                                name="ffcaPantryRoomsColl"
                                                className="form-control" onKeyPress={(e) => { allowNumbersOnly(e); }} onPaste={(e) => handlePaste(e)}
                                                onKeyUp={(e) => handleKeyUp("ffcaPantryRoomsCollDeficiency", e.target.value, Administrative?.pantry_rooms)} />
                                                <ErrorMessage name="ffcaPantryRoomsColl" component="div" className="text-error" />
                                            </td>

                                            <td><Field
                                                type="text"
                                                name="ffcaPantryRoomsCollDeficiency"
                                                className="form-control"
                                                value={FfcaAdminstrativeFormk.values.ffcaPantryRoomsCollDeficiency}

                                                disabled
                                            /> </td>
                                            <td>{Administrative?.pantry_area} </td>
                                            <td><Field
                                                type="text"
                                                name="ffcaPantryRoomsByUniversity"
                                                className="form-control" onKeyPress={(e) => { AllowFloats(e); }}
                                                onKeyUp={(e) => handleKeyUp("ffcaPantryRoomsDeficiency", e.target.value, Administrative?.pantry_area)} />
                                                <ErrorMessage name="ffcaPantryRoomsByUniversity" component="div" className="text-error" />
                                            </td>

                                            <td><Field
                                                type="text"
                                                name="ffcaPantryRoomsDeficiency"
                                                value={FfcaAdminstrativeFormk.values.ffcaPantryRoomsDeficiency}
                                                className="form-control"
                                                disabled
                                            /> </td>
                                        </tr>
                                        <tr>
                                            <td className='text-left'>Examination Control Office	 </td>
                                            <td> {Administrative?.examination_rooms}</td>
                                            <td><Field
                                                type="text"
                                                name="ffcaExaminationRoomsColl"
                                                className="form-control" maxLength={8} onKeyPress={(e) => { allowNumbersOnly(e); }} onPaste={(e) => handlePaste(e)}
                                                onKeyUp={(e) => handleKeyUp("ffcaExaminationRoomsCollDeficiency", e.target.value, Administrative?.examination_rooms)} />
                                                <ErrorMessage name="ffcaExaminationRoomsColl" component="div" className="text-error" />
                                            </td>

                                            <td><Field
                                                type="text"
                                                name="ffcaExaminationRoomsCollDeficiency"
                                                className="form-control"
                                                value={FfcaAdminstrativeFormk.values.ffcaExaminationRoomsCollDeficiency}
                                                disabled
                                            /> </td>
                                            <td>{Administrative?.examination_area} </td>
                                            <td><Field
                                                type="text"
                                                name="ffcaExaminationRoomsByUniversity"
                                                className="form-control" onKeyPress={(e) => { AllowFloats(e); }}
                                                onKeyUp={(e) => handleKeyUp("ffcaExaminationRoomsDeficiency", e.target.value, Administrative?.examination_area)} />
                                                <ErrorMessage name="ffcaExaminationRoomsByUniversity" component="div" className="text-error" />
                                            </td>

                                            <td><Field
                                                type="text"
                                                name="ffcaExaminationRoomsDeficiency"
                                                className="form-control"
                                                value={FfcaAdminstrativeFormk.values.ffcaExaminationRoomsDeficiency} disabled /> </td>
                                        </tr>
                                        <tr>
                                            <td className='text-left'>Placement Office	 </td>
                                            <td> {Administrative?.placement_rooms}</td>
                                            <td><Field
                                                type="text"
                                                name="ffcaPlacementRoomsColl"
                                                className="form-control" maxLength={8} onKeyPress={(e) => { allowNumbersOnly(e); }} onPaste={(e) => handlePaste(e)}
                                                onKeyUp={(e) => handleKeyUp("ffcaPlacementRoomsCollDeficiency", e.target.value, Administrative?.placement_rooms)} />
                                                <ErrorMessage name="ffcaPlacementRoomsColl" component="div" className="text-error" />
                                            </td>

                                            <td><Field
                                                type="text"
                                                name="ffcaPlacementRoomsCollDeficiency"
                                                value={FfcaAdminstrativeFormk.values.ffcaPlacementRoomsCollDeficiency}
                                                className="form-control"
                                                disabled
                                            /> </td>
                                            <td>{Administrative?.placement_area} </td>
                                            <td><Field
                                                type="text"
                                                name="ffcaPlacementRoomsByUniversity"
                                                className="form-control" onKeyPress={(e) => { AllowFloats(e); }}
                                                onKeyUp={(e) => handleKeyUp("ffcaPlacementRoomsDeficiency", e.target.value, Administrative?.placement_area)} />
                                                <ErrorMessage name="ffcaPlacementRoomsByUniversity" component="div" className="text-error" />
                                            </td>

                                            <td><Field
                                                type="text"
                                                name="ffcaPlacementRoomsDeficiency"
                                                value={FfcaAdminstrativeFormk.values.ffcaPlacementRoomsDeficiency}
                                                className="form-control"
                                                disabled
                                            /> </td>
                                        </tr>
                                        <tr>
                                            <td className='text-left'>IQAC Room	 </td>
                                            <td> {Administrative?.iqac_rooms}</td>
                                            <td><Field
                                                type="text"
                                                name="ffcaIqacRoomsColl"
                                                className="form-control" maxLength={8} onKeyPress={(e) => { allowNumbersOnly(e); }} onPaste={(e) => handlePaste(e)}
                                                onKeyUp={(e) => handleKeyUp("ffcaIqacRoomsCollDeficiency", e.target.value, Administrative?.iqac_rooms)} />
                                                <ErrorMessage name="ffcaIqacRoomsColl" component="div" className="text-error" />

                                            </td>

                                            <td><Field
                                                type="text"
                                                name="ffcaIqacRoomsCollDeficiency"
                                                className="form-control"
                                                value={FfcaAdminstrativeFormk.values.ffcaIqacRoomsCollDeficiency}

                                                disabled
                                            /> </td>
                                            <td>{Administrative?.iqac_area} </td>
                                            <td>
                                                <Field
                                                    type="text"
                                                    name="ffcaIqacRoomsByUniversity"
                                                    className="form-control" onKeyPress={(e) => { AllowFloats(e); }}
                                                    onKeyUp={(e) => handleKeyUp("ffcaIqacRoomsDeficiency", e.target.value, Administrative?.iqac_area)} />
                                                <ErrorMessage name="ffcaIqacRoomsByUniversity" component="div" className="text-error" />
                                            </td>

                                            <td><Field
                                                type="text"
                                                name="ffcaIqacRoomsDeficiency"
                                                value={FfcaAdminstrativeFormk.values.ffcaIqacRoomsDeficiency}
                                                className="form-control"
                                                disabled
                                            /> </td>
                                        </tr>

                                    </tbody>

                                </table>
                            </div>
                            <div className="button-cend pt-1">
                                <button type='submit' className='btn btn-success btn-sm float-end rounded mb-2'>Submit</button>
                            </div>
                        </bie.Row>
                    </Form>
                </FormikProvider>
            </bie.Container>
        </>
    )
}
